import type { Template } from '../types';

interface TemplateSelectorProps {
  value: Template;
  onChange: (t: Template) => void;
}

const TEMPLATES = [
  { value: 'status_update',        label: 'Status update' },
  { value: 'risk_escalation',      label: 'Risk / escalation' },
  { value: 'metrics_translation',  label: 'Metrics translation' },
  { value: 'executive_summary',    label: 'Executive summary' },
] as const;

export function TemplateSelector({ value, onChange }: TemplateSelectorProps) {
  return (
    <>
      <style>{`
        .template-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          margin-bottom: 20px;
        }
        .template-pill {
          padding: 10px 14px;
          font-size: 13px;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.2s;
          text-align: center;
          font-weight: 500;
          font-family: 'Inter', system-ui, sans-serif;
          border: 1px solid var(--border);
          background: var(--bg-card);
          color: var(--text-muted);
        }
        .template-pill.active {
          border-color: var(--accent);
          background: var(--pill-active-bg);
          color: var(--accent);
          box-shadow: 0 0 12px rgba(0,212,255,0.12);
        }
        .template-pill:hover:not(.active) {
          border-color: rgba(0,212,255,0.2);
          color: var(--text-secondary);
        }
        /* Last item spans full width if odd count */
        .template-pill:last-child:nth-child(odd) {
          grid-column: span 2;
        }
      `}</style>
      <div className="template-grid">
        {TEMPLATES.map(t => (
          <button
            key={t.value}
            onClick={() => onChange(t.value as Template)}
            className={`template-pill ${value === t.value ? 'active' : ''}`}
          >
            {t.label}
          </button>
        ))}
      </div>
    </>
  );
}
